export class State {
  stateId: number;
  name: string;
  id: number;
}
